import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowRight, Layers } from "lucide-react";

// Designs to spotlight on the home page, in display order.
const SPOTLIGHT = [
  "Fetching Dinner",
  "We Have Heart",
  "Deer & Shotguns",
  "Country Girls Do It Better",
  "EVR Stars Logo",
];

export default function FeaturedDesigns() {
  const [byName, setByName] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products").then((r) => {
      const map = {};
      for (const p of r.data) {
        for (const key of SPOTLIGHT) {
          if (p.name.toLowerCase().includes(key.toLowerCase())) {
            if (!map[key]) map[key] = p;
          }
        }
      }
      setByName(map);
    }).finally(() => setLoading(false));
  }, []);

  const rows = SPOTLIGHT.map((n) => ({ name: n, prod: byName[n] })).filter((r) => r.prod);

  if (!loading && rows.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-20" data-testid="featured-designs">
      <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
        <div>
          <div className="font-anton uppercase tracking-[0.3em] text-[#DD5422] text-sm mb-2 flex items-center gap-2">
            <Layers className="w-4 h-4" /> / Hot Drops
          </div>
          <h2 className="font-anton text-4xl md:text-6xl uppercase tracking-tight">Featured Designs</h2>
          <p className="text-[#8D9688] mt-3 max-w-xl">Each design — on tees, hoodies, and mugs. Pick the look, pick the gear.</p>
        </div>
        <Link to="/designs" data-testid="featured-see-all"
          className="font-anton uppercase tracking-widest text-sm border-2 border-[#DD5422] text-[#DD5422] px-5 py-3 hover:bg-[#DD5422] hover:text-[#0A0E0B] transition-colors flex items-center gap-2">
          See All Designs <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {rows.map(({ name, prod }, i) => (
          <Link key={name} to={`/designs/${encodeURIComponent(name)}`}
            data-testid={`spotlight-${name}`}
            className="group bg-[#151A14] border-2 border-[#2C332A] hover:border-[#DD5422] transition-all hover:-translate-y-1 fade-up"
            style={{ animationDelay: `${i * 0.07}s` }}>
            <div className="aspect-square overflow-hidden bg-[#0A0E0B]">
              <img src={prod.image_url} alt={name}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-3">
              <div className="font-anton uppercase tracking-tight text-sm md:text-base line-clamp-2 min-h-[2.5rem]">{name}</div>
              <div className="text-[10px] uppercase tracking-widest text-[#DD5422] mt-1">from ${prod.price_from.toFixed(2)}</div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
